/* eslint-disable func-names */
/* eslint-disable no-use-before-define */
import _ from 'lodash';

const { Collection } = Mobi2Go._class.Common;

/*------------------------------------------------------------------------------
 * Global access
 */
Mobi2Go._class = Mobi2Go._class || {};

function support_format_webp()
{
    var elem = document.createElement('canvas');

    if (!!(elem.getContext && elem.getContext('2d')))
    {
        // was able or not to get WebP representation
        return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }
    else
    {
        // very old browser like IE 8, canvas not supported
        return false;
    }
}
Mobi2Go.webp_support = Mobi2Go.webp_support || support_format_webp();

Mobi2Go._class.MenuItem = {
    Menu,
    Category,
    Product,
    ModifierGroup,
    Modifier,
};

const no_cdn =
    (
        Mobi2Go.app.base_url !== 'https://www.mobi2go.com'
        && Mobi2Go.app.base_url !== 'https://production-canary-php8.mobi2go.com'
        && Mobi2Go.app.base_url !== 'https://production-canary.mobi2go.com'
    ) ||
    !!Mobi2Go.helpers.getQueryStringAsObject().no_cdn;

/*------------------------------------------------------------------------------
 * Menu
 * Represents a Mobi2Go\HeadOffice\Menu\Menu
 */
function Menu(properties) {
    if (!(this instanceof Menu)) {
        return new Menu(properties);
    }
    _.extend(this, properties);

    this._products = null;
}
Menu.prototype.toString = toString;
Menu.prototype.hasTag = hasTag;
Menu.prototype.getCategories = function() {
    const category_ids = this.categories;
    const categories = Mobi2Go.Menu.getCategories();
    const menu_categories = [];

    _.each(category_ids, function(id) {
        const category = categories.find({ id });
        if (category) {
            menu_categories.push(category);
        }
    });

    return Collection(menu_categories);
};
Menu.prototype.getCategoryProducts = function() {
    this._products =
        this._products ||
        this.getCategories().reduce(function(products, category) {
            return _.union(products, category.getProducts().toArray());
        }, []);

    return Collection(this._products);
};

Menu.prototype.containsProduct = function(product) {
    return !!this.getCategoryProducts().find({ id: product.id });
};

Menu.prototype.getProductByName = function(display_name) {
    return this.getCategoryProducts().find({ backend_name: display_name });
};

Menu.prototype.getProductByDisplayName = function(display_name) {
    return this.getCategoryProducts().find({ name: display_name });
};

Menu.prototype.getProductById = function(id) {
    return this.getCategoryProducts().find({ id });
};

/*------------------------------------------------------------------------------
 * Category
 * Represents a Mobi2Go\HeadOffice\Menu\Category
 */
function Category(properties) {
    if (!(this instanceof Category)) {
        return new Category(properties);
    }
    _.extend(this, properties);
    this._cache = null;

    if (no_cdn) {
        this.image_src = this.image_id
            ? `${Mobi2Go.app.base_url}/api/1/images/${this.image_id}?no_cdn`
            : null;
    } else {
        let suffix = '700';
        if (Mobi2Go.webp_support) {
            suffix = 'webp-thumbnail';
        }
        this.image_src = this.image_id
            ? `https://static.mobi2go.com/images/${this.image_id}-${suffix}`
            : null;
    }
}

Category.prototype.toString = toString;
Category.prototype.hasTag = hasTag;
Category.prototype.getProducts = function() {
    if (this._cache) {
        return this._cache;
    }

    const product_ids = this.products;
    const products = Mobi2Go.Menu.getProducts();
    const category_products = [];

    _.each(product_ids, (id, i) => {
        const product = products.find({ id });
        if (product) {
            product.setCategory(this);
            product.setCategoryListPosition(i + 1);
            category_products.push(product);
        }
    });

    this._cache = Collection(category_products);

    return this._cache;
};

Category.prototype.containsProduct = function(product) {
    return this.getProducts().find(function(category_product) {
        // eslint-disable-next-line no-nested-ternary
        return product.id
            ? product.id ===
                category_product.id
            : product.name
            ? product.name ===
            category_product.name
            : false;
    });
};

/*------------------------------------------------------------------------------
 * Product
 * Represents a Mobi2Go\HeadOffice\Menu\Product
 */
function Product(properties) {
                                 if (!(this instanceof Product)) {
                                     return new Product(properties);
                                 }
                                 _.extend(this, properties);

                                 if (no_cdn) {
                                     this.image_src = this.image_id
                                         ? `${Mobi2Go.app.base_url}/api/1/images/${this.image_id}?no_cdn`
                                         : null;
                                 } else {
                                     let suffix = '700';
                                     if (Mobi2Go.webp_support) {
                                         suffix = 'webp-thumbnail';
                                     }
                                     this.image_src = this.image_id
                                         ? `https://static.mobi2go.com/images/${this.image_id}-${suffix}`
                                         : null;
                                 }

                                 this._modifiers = null;
                                 this._size_options = null;
                                 this.category = null;
                                 this.category_list_position = null;
                                 this.tax = properties.tax;
                             }

Mobi2Go._class.MenuItem.Product = Product;

Product.prototype.toString = toString;
Product.prototype.hasTag = hasTag;
Product.prototype.getPrice = getPrice;
Product.prototype.getProperty = getProperty;

Product.prototype.setCategory = function(category) {
    this.category = category;
};
Product.prototype.setCategoryListPosition = function(position) {
    this.category_list_position = position;
};

Product.prototype.getModifierGroups = function() {
    const modifier_group_ids = this.modifier_groups;
    const modifier_groups = Mobi2Go.Menu.getModifierGroups();
    const product_modifier_groups = [];

    _.each(modifier_group_ids, function(id) {
        const modifier_group = modifier_groups.find({ id });
        if (modifier_group) {
            product_modifier_groups.push(modifier_group);
        }
    });

    return Collection(product_modifier_groups);
};
Product.prototype.getModifierGroupModifiers = function() {
    this._modifiers =
        this._modifiers ||
        this.getModifierGroups().reduce(function(modifiers, modifier_group) {
            return _.union(modifier_group.getModifiers().toArray(), modifiers);
        }, []);

    return Collection(this._modifiers);
};
Product.prototype.getModifierByDisplayName = function(name) {
    return this.getModifierGroupModifiers().find({ name });
};
Product.prototype.getModifiers = function() {
    return this.getModifierGroupModifiers();
};
Product.prototype.getSizeModifierGroup = function() {
    return this.getModifierGroups().find({ type: 'size' });
};
Product.prototype.getSizeOptions = function() {
    const modifier_group = this.getSizeModifierGroup();
    const product_price = this.getPrice();

    if (!modifier_group) {
        return [];
    }

    return modifier_group.getModifiers().map(modifier => ({
        ...modifier,
        price: modifier
            .getPrice()
            .clone()
            .add(product_price),
    }));
};
Product.prototype.getNonSizeModifierGroups = function() {
    return Collection(this.getModifierGroups().reject({ type: 'size' }));
};
Product.prototype.createOrderProductInstance = function(props = {}) {
    return Mobi2Go._class.OrderProduct({ ...props, menu_product: this });
};
Product.prototype.containsOnlyQuantityModifiers = function() {
    if (!this.getModifiers().collection.length) {
        return false;
    }

    let is_true = true;
    this.getModifiers().each(function(modifier) {
        if (modifier.type !== 'quantity') {
            is_true = false;
        }
    });

    return is_true;
};

Product.prototype.shouldHideQuantitySelector = function() {
    return this.containsOnlyQuantityModifiers() || this.hasTag('hide-quantity');
};

Product.prototype.getPrice = function() {
    const price_value = this.getProperty('price');
    const price = new Mobi2Go._class.Common.Price(price_value);
    price.setTax(this.tax);

    return price;
};

/*--------------------------------------------------------------------------
 * Modifier Group
 * Represents a Mobi2Go\HeadOffice\Menu\ModifierGroup
 */
function ModifierGroup(properties) {
    if (!(this instanceof ModifierGroup)) {
        return new ModifierGroup(properties);
    }
    _.extend(this, properties);
}
ModifierGroup.prototype.toString = toString;
ModifierGroup.prototype.hasTag = hasTag;
ModifierGroup.prototype.getModifiers = function() {
    const modifier_ids = this.modifiers;
    const modifiers = Mobi2Go.Menu.getModifiers();
    const group_modifiers = [];

    _.each(modifier_ids, function(id) {
        const modifier = modifiers.find({ id });
        if (modifier) {
            group_modifiers.push(modifier);
        }
    });

    return Collection(group_modifiers);
};

// Placeholder until backend is ready
ModifierGroup.prototype.getProducts = function() {
    if (this._cache) {
        return this._cache;
    }

    const product_ids = this.products;
    const products = Mobi2Go.Menu.getProducts();
    const group_products = [];

    _.each(product_ids, (id) => {
        const product = products.find({ id });
        if (product) {
            group_products.push(product);
        }
    });

    this._cache = Collection(group_products);

    return this._cache;
};

ModifierGroup.prototype.containsProduct = function(menu_product) {
    return !!this.getProducts().find({ id: menu_product.id });
};

/*------------------------------------------------------------------------------
 * Modifier
 * Represents a Mobi2Go\HeadOffice\Menu\Modifier
 */
function Modifier(properties) {
    if (!(this instanceof Modifier)) {
        return new Modifier(properties);
    }

    this.quantity_limit = 10; // Temp until implemented in backend
    _.extend(this, properties);
}
Modifier.prototype.toString = toString;
Modifier.prototype.getPrice = getPrice;
Modifier.prototype.getProperty = getProperty;
Modifier.prototype.hasTag = hasTag;
Modifier.prototype.getPriceBySize = function(size_menu_modifier) {
    return this.size_prices[size_menu_modifier.id];
};
Modifier.prototype.hasSizePrices = function() {
    return !!_.keys(this.size_prices).length;
};

Modifier.prototype.getPropertyBySize = function(key, size_menu_modifier) {
    const size_tiers = this.getProperty('size_tiers') || this.size_tiers;

    if (size_menu_modifier && size_tiers) {
        if (
            size_tiers[size_menu_modifier.id] &&
            size_tiers[size_menu_modifier.id][key]
        ) {
            return size_tiers[size_menu_modifier.id][key];
        }
        if (
            size_tiers[size_menu_modifier.backend_name] &&
            size_tiers[size_menu_modifier.backend_name][key]
        ) {
            return size_tiers[size_menu_modifier.backend_name][key];
        }
    }

    return this.getProperty(key);
};
Modifier.prototype.hasSizeTiers = function() {
    return !!this.size_tiers;
};

/*------------------------------------------------------------------------------
 */
function toString() {
    return this.name;
}

function hasTag(tag) {
    return _.includes(this.tags, tag);
}

function getPrice() {
    const price = this.getProperty('price');
    return new Mobi2Go._class.Common.Price(price);
}

function getProperty(key) {
    // Check property 'tiers'
    if (this.property_tiers !== undefined) {
        const tier_index = getMenuTierId();
        const level_index = getMenuLevelId();

        if (
            this.property_tiers &&
            this.property_tiers[tier_index] !== undefined &&
            this.property_tiers[tier_index][key] !== undefined
        ) {
            if (_.isObject(this.property_tiers[tier_index][key])) {
                if (
                    this.property_tiers[tier_index][key][level_index] !==
                    undefined
                ) {
                    return this.property_tiers[tier_index][key][level_index];
                }
            } else {
                return this.property_tiers[tier_index][key];
            }
        }
    }

    return this[key];
}

// This is a weird global dependency. Needs a better solution, but it works.
function getMenuTierId() {
    if (Mobi2Go.Order) {
        return Mobi2Go.Order.getMenuTierId();
    }

    return null;
}

function getMenuLevelId() {
    if (Mobi2Go.Order) {
        return Mobi2Go.Order.getMenuLevelId();
    }

    return null;
}
